import { render, staticRenderFns } from "./studyChatModal.vue?vue&type=template&id=36e24b7d&scoped=true&"
import script from "./studyChatModal.vue?vue&type=script&lang=js&"
export * from "./studyChatModal.vue?vue&type=script&lang=js&"
import style0 from "./studyChatModal.vue?vue&type=style&index=0&id=36e24b7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e24b7d",
  null
  
)

export default component.exports